export default __webpack_public_path__ + "static/media/FlightHotel.d3cb84eb.png";